// Header.js
import React from 'react';
import styled from 'styled-components';


const HeaderStyled = styled.header`
  padding: 20px;
  text-align: center;
  width: 35%;
  max-width: 500px;
  font-family: 'Comic Sans MS', cursive, sans-serif;
  transition: all 0.3s ease;
  
  img {
    width: 100%;
    filter: drop-shadow(0 0 3px purple) drop-shadow(0 0 25px purple);
    transition: transform 0.3s ease;
    
    &:hover {
      transform: scale(1.05);
    }
  }

  @media (max-width: 768px) {
    width: 80%;
  }
`;

const AnimatedHeader = () => {
  return (
    <HeaderStyled>
      <>  </>
    </HeaderStyled>
  );
};

export default AnimatedHeader;
